<template>
  <swiper :options="swiperOption" ref="mySwiper">
    <!-- slides -->
    <swiper-slide><img src="../../assets/images/banner-500/home1.jpg"></swiper-slide>
    <swiper-slide><a @click="setroters('/join/index')"><img src="../../assets/images/banner-500/home2.jpg"></a></swiper-slide>
    <!-- Optional controls -->
    <div class="swiper-pagination"  slot="pagination"></div>
  </swiper>
</template>

<script>
  export default {
    name: 'carrousel',
    data() {
      return {
        swiperOption: {
          // 参照：www.swiper.com.cn/api/index.html
          pagination: {
            el: '.swiper-pagination'
          },
          autoplay:{
            delay:5000
          }
          // some swiper options/callbacks
          // 所有的参数同 swiper 官方 api 参数
          // ...
        }
      }
    },
    methods:{
      setroters(src) {
        this.$router.push(src);
      }
    }
  }
</script>
<style scoped>
  /*字体*/
  swiper{
    width: 1800px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/commoncoms/banner.vue